export enum MountMaterialStatus {
  ACTIVE = 'mount-material-status__title',
  NEXT = 'mount-material-status__title mount-material-status__title--next'
}
